<template lang="pug">
.container(v-if='medium')
  el-form(id="MediumBasicEditor-form" @submitNameForm.native.prevent='submitNameForm()', inline)
    el-form-item
      MediumIcon.icon-name(:medium="medium")
      el-input.name-input(id="MediumBasicEditor-nameInput" :placeholder='$t("Medium name")', v-model='medium.name', ref='nameInput')
    el-form-item(:label="$t('')", v-if='medium.type === "Video"')
      font-awesome-icon.icon-mute(:icon="medium.muted ? 'volume-off' : 'volume-up'")
    el-form-item(:label="$t('')", v-if='medium.type === "Video"')
      el-switch.muted-switch(
        id="MediumBasicEditor-mutedSwitch",
        :placeholder='$t("Muted")',
        v-model='medium.muted',
        inactive-color="#13ce66",
        active-color="#ff4949",
        ref='mutedInput',
      )
    el-form-item
      el-button(id="MediumBasicEditor-saveButton" @click='submitNameForm()', type="success", size="small", :title="$t('Save')", :disabled='saving')
        font-awesome-icon(icon="save")
        span &nbsp;  {{ saving ? $t('saving...') : $t('save')}}
      el-button(id="MediumBasicEditor-untestButton" v-if='medium.test && !$store.state.User.user.test', @click='showUntest()', type="success", size="small", :title="$t('Untest')", :disabled='saving')
        font-awesome-icon(icon="unlock")
        span &nbsp; {{ $t('Un-test medium') }}
  el-tabs(type='border-card', v-model='activeTabName')
    el-tab-pane(id="MediumBasicEditor-infoPane" name='info')
      span(slot='label')
        font-awesome-icon(icon="info")
        span &nbsp; {{$t('Info')}}
      .thumbnail-container.float-left
        .thumbnail(v-if="!medium.type.startsWith('PlayList') && medium.type !== 'Audio' && medium.type !== 'HTML5app' && medium.type !== 'Custom'")
          .float-left.height-container
            .rotated-90ccw.height-value {{file.originalHeightPixels}} px
          .float-left
            img(:src="getMediumThumbnailPath(medium)", @click="playMedium(medium)")
            .width-value {{file.originalWidthPixels}} px
      MediumBasicInfo(id="MediumBasicEditor-infoPaneMediumBasicInfo" :medium='medium')
    el-tab-pane(id="MediumBasicEditor-tagsPane" name='tags')
      span(slot='label')
        font-awesome-icon(icon="tags")
        span &nbsp; {{$t('Tags')}}
      el-button.float-right(id="TagFilterMedia-switchFilterViewButton" type='text', size='mini', @click='switchTagViewMode()', :title='$t("Switch filter view")')
        font-awesome-icon(:icon="!mediumTagDropdownViewActive ? 'caret-square-down' : 'cloud'")
      MediumTagsEditor(v-if='!mediumTagDropdownViewActive', id="MediumBasicEditor-tagsPaneMediumTagsEditor" :mediumId='mediumId')
      MediumTagsEditorDropdown(v-else, id="MediumBasicEditor-tagsPaneMediumTagsEditor" :mediumId='mediumId')
    el-tab-pane(id="MediumBasicEditor-appearancesPane" name='usage')
      span(slot='label')
        font-awesome-icon(icon="broadcast-tower")
        span &nbsp; {{$t('Appearances')}}
      MediumInPlaylists(id="MediumBasicEditor-appearancesPaneMediumInPlaylists" :medium='medium')
    el-tab-pane(
      name='configure',
      id="MediumBasicEditor-configurePane",
      v-if='["PlayListExtended", "HTML5app"].includes(medium.type)'
    )
      span(slot='label')
        font-awesome-icon(icon="cogs")
        span &nbsp; {{$t('Configure')}}
      ExtensionConfigEditor(:mediumId='medium.id')
    el-tab-pane(
      name='sort',
      id="MediumBasicEditor-reorderPlaylist",
      v-if='medium.type.startsWith("PlayList")'
    )
      span(slot='label')
        font-awesome-icon(icon="sort-alpha-down")
        span &nbsp; {{$t('Sort')}}
      PlayListSorter(:mediumId='medium.id')
    el-tab-pane(
      name='owner',
      id="MediumBasicEditor-ownerPane",
    )
      span(slot='label')
        font-awesome-icon(icon="user-edit")
        span &nbsp; {{$t('Editors')}}
      MediumEditors(:medium='medium')
    el-tab-pane(
      name='playproperties',
      id="MediumBasicEditor-propertiesPane",
      v-if='!medium.type.startsWith("PlayList")'
    )
      span(slot='label')
        font-awesome-icon(icon="clock")
        span &nbsp; {{$t('Play Duration')}}
      MediumPlayProperties(:medium='medium')
    el-tab-pane(
      name='playLink',
      id="MediumBasicEditor-playLinkPane",
      v-if='medium.type.startsWith("PlayList")'
    )
      span(slot='label')
        font-awesome-icon(icon="link")
        span &nbsp; {{$t('Play Link')}}
      p.selectable(v-if='medium.previewToken') {{ getLinkURL() }}
      el-button(id="MediumBasicEditor-saveButton" @click='generateLink(); submitLinkForm()', type="success", size="small", :title="$t('Generate Link')", :disabled='saving')
        span {{  $t('Generate Link of preview for not logged-in users') }}
      el-button(v-if='medium.previewToken', id="MediumBasicEditor-saveButton" @click='removeLink(); submitLinkForm()', type="danger", size="small", :title="$t('Remove Link')", :disabled='saving')
        span {{  $t('Remove Link') }}
    el-tab-pane(
      name='preview',
      id="MediumBasicEditor-previewPane",
      v-if='medium.type.startsWith("PlayList")'
    )
      span(slot='label')
        font-awesome-icon(icon="desktop")
        span &nbsp; {{$t('Preview')}}
      FreePlayListPreview(:mediumId='medium.id', :width='1920', :height='1080', :scale='0.5')
  el-dialog(:close-on-click-modal="false", :visible.sync="playMediumVisible", @close='closePlayMedium()', append-to-body, width="60%")
    Player(:playedMedium='medium', @close-PlayMedium="closePlayMedium()")
  el-dialog(:close-on-click-modal="false", :visible.sync="untestMediumVisible", @close='closeUntestMedium()', append-to-body, width="60%")
    UntestMedium(:medium='medium', @close-untestMedium="closeUntestMedium()")
</template>

<script>
import Vue from 'vue'
import mediaUtils from '../Common/mediaUtils.mixin'
import MediumIcon from './../Common/MediumIcon'
import MediumTagsEditor from './MediumTagsEditor'
import MediumTagsEditorDropdown from './MediumTagsEditorDropdown'
import MediumBasicInfo from './MediumBasicInfo'
import MediumInPlaylists from './MediumInPlaylists'
import ExtensionConfigEditor from './ExtensionConfigEditor'
import MediumEditors from './MediumEditors'
import MediumPlayProperties from './MediumPlayProperties'
import PlayListSorter from './PlayListSorter'
import Player from './../File/Player'
import UntestMedium from './UntestMedium'
import FreePlayListPreview from './FreePlayListPreview'

export default {
  mixins: [mediaUtils],
  props: ['mediumId'],
  components: {
    FreePlayListPreview,
    MediumIcon,
    MediumTagsEditor,
    MediumBasicInfo,
    MediumInPlaylists,
    ExtensionConfigEditor,
    Player,
    UntestMedium,
    PlayListSorter,
    MediumEditors,
    MediumPlayProperties,
    MediumTagsEditorDropdown
  },
  created () {
    this.mediumTagDropdownViewActive = this.$store.state.User.user.mediumTagDropdownViewActive
    this.loadData()
  },
  updated () {
  },
  watch: {
  },
  data () {
    return {
      errors: {
      },
      playMediumVisible: false,
      medium: undefined,
      saving: false,
      untestMediumVisible: false,
      activeTabName: 'info',
      mediumTagDropdownViewActive: false
    }
  },
  methods: {
    getLinkURL () {
      return `${window.location.origin}/#/playlistpreview/${this.medium.previewToken}`
    },
    generateLink () {
      this.medium.previewToken = crypto.randomUUID()
    },
    removeLink () {
      this.medium.previewToken = null
    },
    async loadData () {
      this.medium = await this.$store.dispatch('Medium/getMedium', {
        data: this.mediumId,
        options: { populate: false }
      })
      this.$nextTick(_ => {
        this.$refs.nameInput.focus()
      })
    },
    async submitNameForm () {
      this.saving = true
      await this.$store.dispatch('Medium/saveMediumToServer', {
        data: this.medium,
        columns: ['name', 'muted']
      })
      this.saving = false
      this.$emit('close')
    },
    async submitLinkForm () {
      this.saving = true
      await this.$store.dispatch('Medium/saveMediumToServer', {
        data: this.medium,
        columns: ['previewToken']
      })
      this.saving = false
    },
    closePlayMedium () {
      this.playMediumVisible = false
    },
    playMedium (medium) {
      this.playMediumVisible = true
    },
    showUntest () {
      this.untestMediumVisible = true
    },
    closeUntestMedium () {
      this.untestMediumVisible = false
      this.$emit('close')
    },
    async switchTagViewMode () {
      this.mediumTagDropdownViewActive = !this.mediumTagDropdownViewActive
      await this.setViewPreference()
    },
    async setViewPreference () {
      await Vue.axios.post('user/setViewPreference', {
        mediumTagDropdownViewActive: this.mediumTagDropdownViewActive
      })
      await this.$store.dispatch('User/getMe')
    }
  },
  computed: {
    file () {
      return this.$store.state.File.file_list.find(f => f.id === this.medium.File)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container {
  /* width: 400px; */
  /* text-align: center; */
  padding: 20px;
  .thumbnail-container {
    display: flex;
    .thumbnail {
      img {
        max-height: 200px;
        border: 2px $--border-style-base $--color-text-secondary;
        cursor: zoom-in;
      }
    }
    .playlist {
      max-width: 40%;
    }
    .height-container {
      padding-top: 100px;
      line-height: 20px;
      border: 0px dotted red;
      width: 38px;
    }
    .width-value, .height-value {
      font-size: 12px;
      text-align: center;
      white-space: nowrap;
    }
  }
}
.name-input {
  width: 800px;
  margin-right: 10px;
}
.muted-switch {
  margin-right: 10px;
}
.icon-name {
  padding: 0px 15px 0px 0px;
}
.icon-mute {
    font-size: 20px;
    margin-top: 10px;
    width: 30px;
    padding-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediumBasicEditor.vue